<template>
  <button
    v-if="activityInProgress"
    @click="addKeyMoment"
    title="Add key moment" v-tippy><font-awesome-icon :icon="faCommentPlus" /></button>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCommentPlus } from '@fortawesome/pro-light-svg-icons/faCommentPlus'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import noty from '@/plugins/noty'

const successNotification = noty({
  type: 'success',
  timeout: 3000,
  text: 'Key moment has been added successfully'
})

const errorNotification = noty({
  type: 'error',
  timeout: 3000,
  text: 'Failed to add key moment, please try again'
})

export default {
  components: {
    FontAwesomeIcon
  },
  props: [
    'activity'
  ],
  data () {
    return {
      team: store.get('team'),
      keyMoments: [],
      faCommentPlus
    }
  },
  computed: {
    activityInProgress () {
      return this.activity.status === 'in-progress'
    },
    keyMoment () {
      return this.keyMoments.find(keyMoment => keyMoment.name === 'Key Moment')
    }
  },
  mounted () {
    this.retrieveKeyMoments()
  },
  methods: {
    async retrieveKeyMoments () {
      try {
        const response = await axios.get(`${jiminnyHost()}/api/v1/organizations/${this.team.id}/key-moments`)
        this.keyMoments = response.data
      } catch (error) {
        console.error(error)
      }
    },
    async addKeyMoment () {
      try {
        const now = moment.utc()
        const start = moment.utc(this.activity.actualStartTime)
        const timeInMeeting = Math.max(0, now.diff(start, 'seconds'))

        if (this.keyMoment) {
          await axios.post(`${jiminnyHost()}/api/v1/activity/${this.activity.id}/key-moment`, {
            'start_time': timeInMeeting,
            'momentId': this.keyMoment.id
          })
        } else {
          const response = await axios.post(`${jiminnyHost()}/api/v1/activity/${this.activity.id}/key-moment`, {
            'start_time': timeInMeeting,
            'name': 'Key Moment'
          })

          this.keyMoments.push(response.data)
        }

        successNotification().show()
      } catch (error) {
        console.error(error)
        errorNotification().show()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddKeyMomentButton.vue?8532dc3e